import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import axios from '../../config/axios';
import { getApiUrl } from '../../config/environment';

export interface DentalPatientOption {
  id: string;
  full_name: string;
  cpf?: string | null;
  phone?: string | null;
}

export interface DentalPatientPickerProps {
  value: DentalPatientOption | null;
  onChange: (patient: DentalPatientOption | null) => void;
  label?: string;
  sx?: object;
}

/** Busca de paciente com debounce, usando o mesmo endpoint dos orçamentos. */
const DentalPatientPicker: React.FC<DentalPatientPickerProps> = ({
  value,
  onChange,
  label = 'Paciente',
  sx,
}) => {
  const [options, setOptions] = useState<DentalPatientOption[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(getApiUrl('/clinic/budgets-search/patients'), {
          params: { search },
        });
        if (!cancelled) setOptions(data?.success !== false ? (data?.data || []) : []);
      } catch {
        if (!cancelled) setOptions([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }, 300);

    return () => { cancelled = true; clearTimeout(timer); };
  }, [search]);

  return (
    <Autocomplete
      size="small"
      sx={sx}
      value={value}
      options={options}
      loading={loading}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      getOptionLabel={(option) => option.full_name || ''}
      onChange={(_, selected) => onChange(selected)}
      onInputChange={(_, input, reason) => { if (reason === 'input') setSearch(input); }}
      renderInput={(params) => <TextField {...params} label={label} placeholder="Digite o nome do paciente" />}
    />
  );
};

export default DentalPatientPicker;
